import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Logician_INTP_personality_header from '../../images/personality_types_details/analysts_Logician_INTP_personality_header.svg'
import analysts_Logician_INTP_parenthood from '../../images/personality_types_details/analysts_Logician_INTP_parenthood.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const intp_parents = () => {
    return (
        <Layout>
            <main class="q-td analyst logician">
              {/* --------------------mobile child nav bar------------------------ */}
              <nav className="top-tabs mobile-only" aria-label="Personality description">

<Link to='/personality-types/logician-intp-personality' className="tab with-progress">
    <span className="title">Introduction</span>
    <span className="progress"></span>
</Link>
<Link to="/personality-types/logician-intp-strengths-and-weaknesses" className="tab with-progress">
    <span className="title">Strengths and Weaknesses</span>
    <span className="progress"></span>
</Link>
<Link to="/personality-types/logician-intp-relationships-dating" className="tab with-progress ">
    <span className="title">Romantic Relationships</span>
    <span className="progress"></span>
</Link>
<Link to="/" className="tab with-progress">
    <span className="title">Friendships</span>
    <span className="progress"></span>
</Link>
<Link to="/personality-types/logician-intp-parents" className="tab with-progress active">
    <span className="title">Parenthood</span>
    <span className="progress"></span>
</Link>
<Link to="/personality-types/logician-intp-careers" className="tab with-progress ">
    <span className="title">Career Paths</span>
    <span className="progress"></span>
</Link>
<Link to="/personality-types/logician-intps-at-work" className="tab with-progress ">
    <span className="title">Workplace Habits</span>
    <span className="progress"></span>
</Link>
<Link to="/personality-types/logician-intp-conclusion" className="tab with-progress ">
    <span className="title">Conclusion</span>
    <span className="progress"></span>
</Link>
<Link to="/" className="tab premium">
    <span className="title">Premium Profile</span>
</Link>

</nav>
{/* -------------------- picture and title-------------------------- */}
<header class="type-header analyst logician">

<svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
    <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
    <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
</svg>

<img src={analysts_Logician_INTP_personality_header} class="scene" alt='loading...'/>
<div class="type-info">
    <h1><span>Logician</span> Personality</h1>
    <div class="code">INTP-A / INTP-T</div>
    <a href="#" class="difference">(What’s the difference?)</a>
</div>

</header>



{/* -------------------------side bar section------------------------------------- */}
<div className="with-sidebars">

<div className="sidebar left">
    <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
        <div className="title">Explore This Type</div>
        <ul>
            <li className=""><Link to='/personality-types/logician-intp-personality'>Introduction</Link></li>
            <li className=""><Link to="/personality-types/logician-intp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
            <li className=""><Link to="/personality-types/logician-intp-relationships-dating">Romantic Relationships</Link></li>
            <li className=""><Link to="/personality-types/logician-intp-friends">Friendships</Link></li>
            <li className="active"><Link to="/personality-types/logician-intp-parents">Parenthood</Link></li>
            <li className=""><Link to="/personality-types/logician-intp-careers">Career Paths</Link></li>
            <li className=""><Link to="/personality-types/logician-intps-at-work">Workplace Habits</Link></li>
            <li className=""><Link to="/personality-types/logician-intp-conclusion">Conclusion</Link></li>
            <li className="premium"><Link to="/">Premium Profile</Link></li>
        </ul>
    </nav>
    <daily-insight v-cloak personality-type="INTJ"></daily-insight>
</div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

<h1>    Parenthood
</h1>


    <p>In parenting, as with many social roles, Logicians face a robust but healthy challenge. At times, they may be baffled by their children’s messy, irrational, and ever-changing – but completely natural – emotions. After all, children have yet to develop the sort of agency and logic that Logicians take for granted.</p>
<p>Still, parenthood can be extremely meaningful for Logicians. With their curiosity and love of learning, parents with this personality type can find great joy in teaching their children about the world. Tolerant and open-minded, Logicians encourage their children to think independently, seek out new knowledge, and voice and defend their own opinions.</p>
<div class="scene">
<img alt="Logician (INTP) parents" src={analysts_Logician_INTP_parenthood} alt="Logician (INTP) parents"/>
</div>
<h2>To Thine Own Self Be True</h2>
<p>Parents with this personality type don’t fret about social expectations. In other words, they rarely obsess over parenting advice or other people’s ideas of how their children should behave. They’re also unlikely to push their children toward a traditional life of school &gt; career &gt; marriage &gt; house &gt; kids &gt; retirement (and in that order, thank you very much).</p>
<div class="description-pullout">Logicians have little interest in exerting control over others. They allow their children to form their own principles and opinions – though they may also share their own perspectives and ideas, just in case.</div><p>This isn’t to say that Logicians don’t have expectations of their children – they do. They expect their children to be self-motivated and independent. They hope that, when their children are old enough, they’ll have the critical-thinking abilities necessary to decide on their own life path and figure out how to go after it.</p>
<h2>The Gift of Freedom</h2>
<p>Logicians encourage their children’s curiosity, giving them the freedom to acquire knowledge and expand their horizons. These parents generally take a relaxed, intellectual approach toward their children. Rather than imposing needless rules or strict schedules, they aim to create a home environment that encourages exploration and independence.</p>
<p>For Logician personalities, honoring their children’s independence is a sign of respect. But for many children (and even young adults), this level of personal freedom can be daunting. If their home life doesn’t include reasonable boundaries and parental guidance, these children may find themselves unfocused or adrift, convinced that they need to figure out the world on their own – a tall order indeed.</p>
<div class="description-pullout">Paradoxically, a stable home base of caring rules and parental validation can be exactly what Logicians’ children need in order to blossom into their unique, independent selves.</div><p>Fortunately, Logicians have the mental flexibility to understand that they can encourage their children’s independence without being too hands-off. Parents with this personality type can reestablish balance by making sure that they’re available to offer advice and support whenever their children need it. They can also set clear, common-sense boundaries and establish reasonable consequences for misbehavior, so that their children can navigate daily life without relying entirely on their own burgeoning self-control.</p>
<h2>A Worthy Challenge</h2>
<p>Offering emotional support may not be easy for Logician parents – in fact, along with establishing rules and boundaries, it may be among their greatest challenges. The good news is that these personalities are more than capable of meeting this challenge, although it can take some effort.</p>
<p>Logicians want to empower their children to solve their own problems and meet their own needs. This is a worthy goal, but children need a steady foundation of validation and support – along with the aforementioned rules and boundaries – before they can tackle the world on their own. To help create this foundation, Logician parents need to express the love, affection, and admiration that they feel for their children.</p>
<div class="description-pullout">Outpourings of affection may seem awkward or over-the-top to rational-minded Logicians, but these words and actions go a long way toward helping children feel loved, accepted, and secure.</div><p>Logicians want nothing more than for their children to grow up smart and independent. As long as parents with this personality type teach empathy alongside rationality, their children can grow into confident adults who know how to ask questions, use their minds, and take care of themselves no matter what comes their way.</p>

<div class="number">05</div>


</article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                    <Link to='/personality-types/logician-intp-friends' className='next-feature'>
                        Friendships
                       <br/><br/>
                       <img src={circleback} width={75} height={75}/>
                       </Link>
                    </div>
                    <div className="part right">
                       <Link to='/personality-types/logician-intp-careers'className='next-feature'>
                       Career Paths
                       <br/><br/>
                       <img src={circleforward} width={75} height={75}/>
                       </Link>
                    </div>
                </div>
                
            </main>
        </Layout>
    )
}

export default intp_parents
